export const SKILLS = [
  { name: "HTML", png: "HTML-logo.png", percentage: 95, description: "Semantic markup & structure" },
  { name: "React", png: "react-logo.png", percentage: 90, description: "Component-based architecture" },
  { name: "PHP", png: "PHP-logo.png", percentage: 85, description: "Server-side logic & APIs" },
  { name: "Javascript", png: "JS-logo.png", percentage: 92, description: "Modern ES6+ development" },
  { name: "CSS", png: "CSS.png", percentage: 90, description: "Advanced styling & layouts" },
  { name: "Laravel", png: "laravel.png", percentage: 80, description: "Full-stack framework" },
  { name: "Node.js", png: "Node.js.png", percentage: 75, description: "Runtime backend environment" },
  { name: "Git", png: "GIT.png", percentage: 85, description: "Version control & collaboration" },
];

export const PROJECTS = [
  {
    id: 1,
    title: "Cabinet Dr. Eddassi Noureddine – Ophtalmologiste Meknès",
    description: "Conception et développement d'une plateforme web moderne pour un cabinet d'ophtalmologie à Meknès, avec un système de prise de rendez-vous en ligne, présentation des services médicaux et optimisation SEO.",
    image: "/Cabinet Dr. Eddassi Noureddine – Ophtalmologiste Meknès.png",
    tags: ["React", "Framer Motion", "UI/UX", "firebase"],
    link: "https://cabinet-dr-eddassi-noureddine.web.app"
  },
  {
    id: 2,
    title: "SPJD – Site Web de Pieces Automobiles",
    description: "Développement d’un site web moderne pour une entreprise spécialisée dans les pièces automobiles japonaises, avec mise en place d’un catalogue produits structuré, optimisation de l’expérience utilisateur et création d’une interface responsive en HTML, CSS et JavaScript.",
    image: "/spjd.png",
    tags: ["HTML", "CSS", "JavaScript"],
    link: "https://github.com/TareQ-BMKR/SPJD-DEMO"
  },
  {
    id: 3,
    title: "ESTRELLA – Site Web de Restaurant",
    description: "Conception et développement d'un site web front-end pour un restaurant, intégrant la présentation du menu, des plats populaires, d'une galerie et d'un système de réservation",
    image: "/Estrella.png",
    tags: ["HTML", "CSS", "JavaScript", "React"],
    link: "https://github.com/TareQ-BMKR/Estrilla-restaurant"
  },
  {
    id: 4,
    title: "ROVA - Gaming Store",
    description: "Développement d’un site web moderne et responsive pour une entreprise gaming, réalisé en HTML, CSS et PHP, avec une interface optimisée et une navigation fluide.",
    image: "/ROVA.png",
    tags: ["html", "css", "php"],
    link: "#"
  }
]